import React, { useState } from "react";
import { DialogHeader, DialogFooter, Dialog, DialogTrigger, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import Button from "./button";

interface ConfirmationProps {
    children: React.ReactNode;
    title?: string;
    description?: string;
    onConfirm?: () => void;
    onCancle?: () => void;
}
export default function Confirmation({ children, title, description, onCancle, onConfirm }: ConfirmationProps) {
    const [open, setOpen] = useState(false);
    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>{children}</DialogTrigger>
            <DialogContent className="mt-8 md:mt-0">
                <DialogHeader>
                    <DialogTitle>{title || "Are you sure?"}</DialogTitle>
                    <DialogDescription>{description || "Are you sure you want to perform this action?"}</DialogDescription>
                </DialogHeader>
                <DialogFooter className="mt-4 gap-2">
                    <Button
                        onClick={() => {
                            setOpen(false);
                            onCancle && onCancle();
                        }}>
                        Cancel
                    </Button>
                    <Button
                        variant="dark"
                        onClick={() => {
                            setOpen(false);
                            onConfirm && onConfirm();
                        }}>
                        Confirm
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
